// selectors
import { getTenantUrlFromAccessToken } from '../../util/tokenUtils';
import type { RootState } from '../store';
export const selectOidcUser = (s: RootState) => s.auth.user;

// If your IdP issues tenantUrl in the ID token/userinfo:
export const selectTenantUrl = (s: RootState): string | null => {
    const user = selectOidcUser(s);
    return getTenantUrlFromAccessToken(user?.access_token);
};

export const selectAccessToken = (s: RootState): string | null => {
    const user = selectOidcUser(s);
    return user?.access_token || null;
};